import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const SvgMovie = ({
  src,
  play = false,
  className,
  onComplete,
  onDataLoaded,
  onEnterFrame,
}: any) => {
  const svgRef: any = useRef();
  const lotRef: any = useRef();

  useEffect(() => {
    if (src) {
      const lottieOpts: any = {
        container: svgRef.current as any,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: src,
      };
      let lot: any = lotRef.current;
      if (!lot) {
        lot = lottie.loadAnimation(lottieOpts);
        lot.addEventListener('data_ready', () => {
          if (onDataLoaded) onDataLoaded(true);
        });
        lot.onComplete = (e: any) => {
          if (onComplete) onComplete(e);
        };
        lot.onEnterFrame = (e: any) => {
          if (onEnterFrame) onEnterFrame(e);
        };
        lotRef.current = lot;
      }

      if (play) {
        lot.play();
      } else {
        lot.stop();
        // lot.goToAndStop(0);
        // lot.destroy();
        // lotRef.current = null;
      }
    }
  }, [src, play]);

  return <div ref={svgRef} className={`svg-movie ${className ? className : ''}`}></div>;
};

export default SvgMovie;
